import axios from 'axios';

// Membuat instance Axios
const instance = axios.create({
	baseURL: `${process.env.NEXT_PUBLIC_API_BASE_URL}`,
	// Don't set default Content-Type here - let it be set per request
});

// Request interceptor - set Content-Type based on data type
instance.interceptors.request.use(
	(config) => {
		// For FormData, don't set Content-Type (browser will set it with boundary)
		if (config.data instanceof FormData) {
			// Remove Content-Type to let browser handle it
			if (config.headers) {
				delete config.headers['Content-Type'];
			}
		} else {
			// For other requests, set to JSON
			if (config.headers && !config.headers['Content-Type']) {
				config.headers['Content-Type'] = 'application/json';
			}
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Menambahkan interceptor respons
instance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response && error.response.status === 401) {
			// Mendapatkan elemen window untuk mendispatch event
			if (typeof window !== 'undefined') {
				window.dispatchEvent(new CustomEvent('sessionExpired'));
			}
		}
		return Promise.reject(error);
	}
);

export default instance;
